import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { ownDevicesQuerySchema } from "./device-read";

const deviceId = ownDevicesQuerySchema.shape.cursor.unwrap();
export const recordingSessionCreateSchema = z.strictObject({ deviceId });
export const recordingSessionResultSchema = z.object({
  id: z.uuid(),
  deviceId,
});
export const recordingSessionCreateContract = {
  createRecordingSession: oc
    .errors({
      BAD_REQUEST: { message: "Invalid request" },
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      NOT_FOUND: { message: "Device or session not found" },
      CONFLICT: { message: "Session key was used with another device" },
      METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
      INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
      SERVICE_UNAVAILABLE: { message: "Session creation unavailable" },
    })
    .input(
      z.object({
        query: z.strictObject({}).default({}),
        headers: z.object({ "idempotency-key": z.uuid().toLowerCase() }),
        body: recordingSessionCreateSchema,
      }),
    )
    .meta(
      openapi({
        method: "POST",
        path: "/api/v2/recording-sessions",
        inputStructure: "detailed",
        successStatus: 201,
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(recordingSessionResultSchema),
};
